import React from 'react';

import styles from './Spinner.module.css';

const TITLE = 'Spinner';

export function Spinner() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
      className={styles.spin}
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3.01847 12C3.01847 16.9604 7.03964 20.9815 12 20.9815C16.9604 20.9815 20.9815 16.9604 20.9815 12C20.9815 7.03964 16.9604 3.01847 12 3.01847C7.03964 3.01847 3.01847 7.03964 3.01847 12Z"
        fill="#CCCCCC"
      />
      <path
        d="M12 0C9.77024 -2.65896e-08 7.58459 0.621251 5.68819 1.79407C3.7918 2.96688 2.25968 4.64487 1.26368 6.63982C0.267693 8.63477 -0.152771 10.8678 0.0494542 13.0883C0.25168 15.3089 1.0686 17.4292 2.40857 19.2114C3.74854 20.9936 5.55857 22.3672 7.63563 23.1782C9.71269 23.9892 11.9746 24.2054 14.1677 23.8026C16.3608 23.3998 18.3982 22.394 20.0516 20.8979C21.7049 19.4018 22.9087 17.4746 23.528 15.3326L20.6282 14.4943C20.1647 16.0975 19.2637 17.5399 18.0263 18.6597C16.7888 19.7795 15.2639 20.5323 13.6224 20.8338C11.981 21.1352 10.288 20.9734 8.73344 20.3664C7.17885 19.7595 5.82411 18.7314 4.82119 17.3975C3.81828 16.0635 3.20685 14.4766 3.05549 12.8146C2.90413 11.1526 3.21883 9.48126 3.96429 7.98812C4.70975 6.49498 5.85648 5.23907 7.27586 4.36126C8.69524 3.48346 10.3311 3.01847 12 3.01847L12 0Z"
        fill="#767676"
      />
    </svg>
  );
}
